import { MenuItem } from '@mui/material'
import { FormField } from 'global/components/Form'
import { useAuth } from 'hooks'

interface IProps {
    required?: boolean
}

export function SelectCategorias({ required }: IProps) {
    const {
        decoded: { categoria },
    } = useAuth()

    return (
        <FormField
            required={required}
            select
            name="categoriaId"
            label="Categoria de acesso"
        >
            <MenuItem value={3}>Cliente</MenuItem>
            <MenuItem value={6}>Avaliação</MenuItem>
            {categoria !== 7 && <MenuItem value={7}>Representante</MenuItem>}
        </FormField>
    )
}
